export const getProjectLocation = (location: string | undefined): string => {
    if (location?.toLowerCase() === 'brazilsouth') {
        return 'brazilus';
    }
    const lower = location?.toLowerCase() ?? '';
    if (lower.endsWith('stage')) {
        return `${lower.slice(0, -5)}(stage)`;
    }
    return lower;
};

/**
 * Collapse the legacy "brazilus" control-plane partition label to its real
 * Azure region "brazilsouth". "Brazil US" is an Otto CP slot name, not a
 * region; the region picker exposes only "Brazil South" and `getProjectLocation()`
 * aliases it to the `brazilus` endpoint internally. Apply this helper at the
 * boundaries that receive user-facing region values (store writes, URL params)
 * so old persisted state and bookmarks don't reintroduce the legacy slug.
 */
export const normalizeLocation = (location: string | null | undefined): string | null => {
    if (!location) return null;
    return location.toLowerCase() === 'brazilus' ? 'brazilsouth' : location;
};
